// Ensure that the element with ID 'coordinates' exists
const mapElement = document.getElementById("coordinates");

if (mapElement) {
  // Set the Mapbox access token
  mapboxgl.accessToken =
    "pk.eyJ1IjoidmlhZGlncm91cCIsImEiOiJjbHdnOTI5cGQwMmp3MmpwYW9sMWp6bzF3In0.xZeoQnGcB-dSo6QyS46WhA";

  // Get data from the 'data-start' attribute
  const dataStart = mapElement.getAttribute("data-start");

  const startCoordinates = dataStart
    .split(",")
    .map((coord) => parseFloat(coord.trim())); // Convert strings to numbers

  const start = startCoordinates; // Starting coordinates

  const end = [9.8385807, 46.8065311]; // Ending coordinates

  // Function to get the route
  async function getRoute(start, end, profile = "driving") {
    try {
      const response = await fetch(
        `https://api.mapbox.com/directions/v5/mapbox/${profile}/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
        { method: "GET" }
      );

      const data = await response.json();
      if (data.routes && data.routes.length > 0) {
        return data.routes[0];
      } else {
        throw new Error("Route not found");
      }
    } catch (error) {
      console.error("Error getting route:", error);
      return null;
    }
  }

  // Function to update distance information
  async function updateDistanceData() {
    const drivingRoute = await getRoute(start, end, "driving");
    const walkingRoute = await getRoute(start, end, "walking");

    if (drivingRoute && walkingRoute) {
      const drivingTime = (drivingRoute.duration / 60).toFixed(0); // Convert seconds to minutes
      const walkingTime = (walkingRoute.duration / 60).toFixed(0); // Convert seconds to minutes

      const distanceElement = document.getElementById("articleDistance");
      if (distanceElement) {
        distanceElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
      } else {
        console.error("Element for displaying distance not found.");
      }
    } else {
      console.error("Failed to get routes.");
    }
  }

  // Call the function to display travel times
  updateDistanceData();
}
